<template>
  <div class="wrapper-full">
    <div class="header-container" style="border: none; height: 30px">
      <div style="width: 100%">
        <h1 class="manualtitle">{{ $t("langcfg.txtButDistribution") }}</h1>
      </div>
    </div>
    <el-container>
      <el-main>
        <div style="text-align: right">
          <canvas id="nibutmap" :width="canvasWidth" :height="canvasHeight" />
        </div>
      </el-main>
      <el-aside :style="`width:${getAsideWidth}px;margin-top:40px;height:${dispH}px;${asideStyle}`">
        <div class="nibut-color-bar">
          <svg width="100%" :height="`${svrHeight}px`" style="font-size: 24px">
            <rect
              v-for="id in 15"
              :key="id + 'color'"
              :y="getPosY(id)"
              :width="svrWidth"
              :height="`${svrHeight / 16}`"
              :style="`fill:${getColor(id - 1)};stroke-width:1;stroke:${
                id === 15 ? 'rgba(0,0,0,0)' : 'rgb(0,0,0)'
              }`"
            />
            <rect
              :y="svrHeight - svrHeight / 16"
              :width="svrWidth"
              :height="`${svrHeight / 16}`"
              :style="`fill:white;stroke-width:1;stroke:rgb(0,0,0)`"
            />
            <text v-for="id in 15" :key="id + 'time'" :x="getPosX" :y="getPosY(id, 7)" fill="white">
              <!-- {{ (id-1) * 1.5}} -->
              {{ textWords(id - 1) }}
            </text>
            <text :x="getPosX" :y="getPosY(16, 7) - 3" fill="white">>{{ USERFULTIME }}</text>
          </svg>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { Size } from "../../../mixins";
import { NIBUTCOLORS } from "../../js/consts";
import NibutMapDraw from "../../js/butmapdraw";
export default {
  name: "ButMap",
  data() {
    return {
      validTime: 21
    };
  },
  mixins: [Size],
  props: {
    mapData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    usefulTime: {
      type: Number
    },
    outputStyle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted() {
    // 处理算法的数组成为可用的二维数组
    // eslint-disable-next-line camelcase
    this.drawcanvas();
  },
  updated() {
    this.drawcanvas();
  },
  methods: {
    drawcanvas() {
      let canvas = document.getElementById("nibutmap");
      canvas.width = this.canvasWidth; // 切换左右眼的时候重新绘制canvas
      const LEN = this.mapData.length / 16;
      const LENCIR = 16;
      let mapDataNeeded = [];
      for (let i = 0; i < LEN; i++) {
        let data = [];
        for (let j = 0; j < LENCIR; j++) {
          data.push(this.mapData[j + LENCIR * i]);
        }
        mapDataNeeded.push(data);
      }

      // length 是环数
      let m = new NibutMapDraw(canvas, mapDataNeeded.length, mapDataNeeded, this.usefulTime);
    },
    getColor(index) {
      return NIBUTCOLORS[index];
    },
    getPosY(id, offset = 0) {
      return id === 1
        ? 10 + ((id - 1) * this.svrHeight) / 16 + offset
        : 10 + ((id - 1) * this.svrHeight) / 16 + offset;
    },
    textWords(id) {
      return id * 1.5;
    }
  },
  computed: {
    svrHeight() {
      return this.dispH - 50;
    },
    // 区分大图小图矩形width
    svrWidth() {
      let truesvrWidth;
      if (this.dispW > 1000) {
        truesvrWidth = 100;
      } else {
        truesvrWidth = 40;
      }
      return truesvrWidth;
    },
    getPosX() {
      let trueX;
      this.svrWidth === 100 ? (trueX = 100) : (trueX = 40);
      return trueX;
    },
    // 区分大图小图矩形width
    getAsideWidth() {
      let trueAsideWidth;
      if (this.svrWidth === 100) {
        trueAsideWidth = 200;
      } else {
        trueAsideWidth = 100;
      }
      return trueAsideWidth;
    },
    canvasStyle() {
      return this.outputStyle.canvasStyle;
    },
    asideStyle() {
      return this.outputStyle.asideStyle;
    },
    canvasWidth() {
      return this.dispW - 100;
    },
    canvasHeight() {
      return this.dispH - 20;
    },
    USERFULTIME() {
      return this.usefulTime === -1 ? "0" : Math.round(this.usefulTime);
    }
  }
};
</script>
<style lang="less" scoped>
.nibut-color-bar {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
h1 {
  font-size: 18px;
  margin-top: 10px;
  font-family: "Microsoft YaHei";
}
h1.manualtitle {
  line-height: 40px;
  height: 40px;
  background: #606266;
  text-align: center;
  font-size: 23px;
  margin-top: 0;
  font-family: inherit;
  letter-spacing: 0px;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/basic/ButMap.vue